import { FAQCategory, FAQQuestion } from "@/types/faq";

export const faqCategories: FAQCategory[] = [
  {
    id: "compliance",
    title: "Obligații de Conformitate",
    icon: "Shield",
    description: "Cerințe și obligații legale pentru conformarea cu NIS2",
    subcategories: [
      { id: "masuri-tehnice", title: "Măsuri tehnice", count: 45 },
      {
        id: "masuri-organizatorice",
        title: "Măsuri organizatorice",
        count: 38,
      },
      {
        id: "managementul-riscului",
        title: "Managementul riscului",
        count: 32,
      },
      {
        id: "continuitatea-activitatii",
        title: "Continuitatea activității",
        count: 28,
      },
    ],
  },
  {
    id: "entities",
    title: "Entități Esențiale și Importante",
    icon: "Building2",
    description: "Clasificare și criterii pentru entități vizate",
    subcategories: [
      { id: "entitati-esentiale", title: "Entități esențiale", count: 52 },
      { id: "entitati-importante", title: "Entități importante", count: 48 },
      { id: "sectoare-acoperite", title: "Sectoare acoperite", count: 41 },
      { id: "criterii-dimensiune", title: "Criterii dimensiune", count: 25 },
    ],
  },
  {
    id: "security",
    title: "Măsuri de Securitate",
    icon: "ShieldCheck",
    description: "Măsuri minime de securitate cibernetică obligatorii",
    subcategories: [
      { id: "protectia-retelelor", title: "Protecția rețelelor", count: 56 },
      {
        id: "gestionarea-incidentelor",
        title: "Gestionarea incidentelor",
        count: 44,
      },
      { id: "criptografie", title: "Criptografie", count: 33 },
      { id: "control-acces", title: "Control acces", count: 39 },
    ],
  },
  {
    id: "reporting",
    title: "Raportare și Sancțiuni",
    icon: "AlertTriangle",
    description: "Proceduri de raportare și consecințe neconformității",
    subcategories: [
      {
        id: "incidente-semnificative",
        title: "Incidente semnificative",
        count: 37,
      },
      { id: "termene-raportare", title: "Termene raportare", count: 29 },
      { id: "cert-ro", title: "CERT-RO", count: 22 },
      { id: "amenzi", title: "Amenzi administrative", count: 31 },
    ],
  },
];

export const allCategories: FAQCategory[] = [
  {
    id: "cadrul-legal",
    title: "Cadrul Legal",
    icon: "FileText",
    subcategories: [
      { id: "oug-155", title: "OUG 155/2024", count: 68 },
      { id: "directive-ue", title: "Directive UE", count: 42 },
      { id: "acte-normative", title: "Acte normative conexe", count: 35 },
    ],
  },
  ...faqCategories,
  {
    id: "autoritati",
    title: "Autorități Competente",
    icon: "Landmark",
    subcategories: [
      { id: "dnsc", title: "DNSC", count: 45 },
      {
        id: "autoritati-sectoriale",
        title: "Autorități sectoriale",
        count: 38,
      },
      { id: "supraveghere", title: "Supraveghere", count: 27 },
    ],
  },
  {
    id: "implementare",
    title: "Implementare",
    icon: "CheckCircle2",
    subcategories: [
      { id: "termene", title: "Termene", count: 34 },
      { id: "pasi-necesari", title: "Pași necesari", count: 52 },
      { id: "audit", title: "Audit", count: 29 },
      { id: "certificari", title: "Certificări", count: 23 },
    ],
  },
  {
    id: "furnizori",
    title: "Furnizori de Servicii",
    icon: "Network",
    subcategories: [
      {
        id: "lantul-aprovizionare",
        title: "Lanțul de aprovizionare",
        count: 41,
      },
      { id: "cloud-providers", title: "Cloud providers", count: 36 },
      { id: "relatii-contractuale", title: "Relații contractuale", count: 28 },
    ],
  },
];

export const faqQuestions: FAQQuestion[] = [
  {
    id: "1",
    question: "Ce entități intră sub incidența OUG 155/2024?",
    answer: `Conform OUG 155/2024, sunt vizate următoarele categorii de entități:

ENTITĂȚI ESENȚIALE
Organizații care prestează servicii critice în sectoare precum:
- Energie (producție, transport, distribuție)
- Transport (aerian, feroviar, naval, rutier)
- Infrastructură digitală (puncte de schimb, DNS, TLD)
- Apă potabilă și canalizare
- Sănătate (spitale, laboratoare medicale, farmacii)
- Sectorul bancar și infrastructuri piețelor financiare
- Administrație publică (nivel central și regional)

ENTITĂȚI IMPORTANTE
Organizații din sectoare precum:
- Servicii poștale și de curierat
- Managementul deșeurilor
- Producție chimică
- Producție alimentară și prelucrare
- Producție și prelucrare materii prime critice
- Furnizori de servicii digitale
- Cercetare științifică

CRITERII DE DIMENSIUNE
O entitate este vizată dacă îndeplinește AMBELE criterii:
- Peste 50 de angajați ȘI
- Cifră de afaceri anuală > 10 milioane EUR SAU bilanț total anual > 10 milioane EUR

EXCEPȚII
Micro-întreprinderile și întreprinderile mici (sub 50 angajați sau sub 10 mil EUR) sunt excluse, cu excepția cazului în care sunt singurele furnizoare de servicii esențiale într-o anumită regiune.`,
    category: "entities",
    subcategory: "entitati-esentiale",
    tags: ["Entități esențiale", "Criterii", "OUG 155/2024"],
    votes: 1847,
    views: 12456,
    lastUpdated: "2024-09-15",
    articleReference: "Art. 5-8 din OUG 155/2024",
    relatedQuestions: ["2", "3", "8"],
    urgent: true,
  },
  {
    id: "2",
    question: "Care sunt termenele de conformare cu NIS2 în România?",
    answer: `Termene cheie pentru conformarea cu OUG 155/2024:

17 OCTOMBRIE 2024
Data intrării în vigoare a OUG 155/2024 - Legislația devine aplicabilă

17 APRILIE 2025
Termen pentru implementarea măsurilor minime de securitate cibernetică:
- Politici de gestionare a riscurilor
- Proceduri de gestionare a incidentelor
- Managementul continuității activității
- Securitatea lanțului de aprovizionare

17 OCTOMBRIE 2025
Termen pentru conformare completă și finalizare toate cerințele:
- Implementarea completă a tuturor măsurilor
- Raportare către autoritățile competente
- Desemnarea reprezentantului legal responsabil
- Completarea programelor de formare a personalului

IMPORTANT
Întârzierile în implementare pot duce la:
- Avertismente oficiale
- Amenzi administrative (până la 10.000.000 EUR sau 2% din cifra de afaceri anuală globală)
- Suspendarea temporară a certificatelor de conformitate
- Obligarea la audituri periodice suplimentare

RECOMANDĂRI
- Începeți evaluarea conformității IMEDIAT
- Alocați resurse dedicate pentru implementare
- Solicitați consultanță specializată dacă este necesar
- Nu amânați până la apropierea termenelor`,
    category: "implementare",
    subcategory: "termene",
    tags: ["Termene", "Obligatoriu", "Termen 2025", "Urgent"],
    votes: 2134,
    views: 15789,
    lastUpdated: "2024-09-20",
    articleReference: "Art. 45 din OUG 155/2024",
    relatedQuestions: ["1", "4", "6"],
    urgent: true,
  },
  {
    id: "3",
    question: "Ce înseamnă entitate esențială vs entitate importantă?",
    answer: `Diferențele cheie între cele două categorii de entități:

ENTITĂȚI ESENȚIALE

Definiție: Organizații care furnizează servicii vitale pentru funcționarea societății și economiei.

Sectoare incluse:
- Energie, Transport, Infrastructură digitală, Apă, Sănătate, Sectorul bancar, Administrație publică

Obligații suplimentare:
- Supraveghere mai strictă de către DNSC
- Audituri de securitate mai frecvente (anual)
- Raportare imediată a incidentelor (24h)
- Cerințe mai stricte pentru managementul de vârf
- Planuri de continuitate mai detaliate

Amenzi posibile:
- Până la 10.000.000 EUR sau 2% din cifra de afaceri anuală globală (suma mai mare)

ENTITĂȚI IMPORTANTE

Definiție: Organizații care furnizează servicii importante, dar a căror perturbare nu ar avea un impact critic imediat.

Sectoare incluse:
- Servicii poștale, Managementul deșeurilor, Producție chimică, Producție alimentară, Furnizori servicii digitale, Cercetare

Obligații:
- Supraveghere standard de către autorități sectoriale
- Audituri de securitate periodice (la 2-3 ani)
- Raportare incidente (72h)
- Măsuri minime de securitate obligatorii
- Planuri de continuitate standard

Amenzi posibile:
- Până la 7.000.000 EUR sau 1,4% din cifra de afaceri anuală globală (suma mai mare)

CUM SE DETERMINĂ CATEGORIA
DNSC și autoritățile sectoriale competente clasifică entitățile pe baza:
1. Importanței serviciului pentru societate
2. Dependențe între sectoare
3. Numărul de utilizatori afectați
4. Efectul unei perturbări asupra activității economice`,
    category: "entities",
    subcategory: "entitati-esentiale",
    tags: ["Entități esențiale", "Entități importante", "Clasificare"],
    votes: 1523,
    views: 9876,
    lastUpdated: "2024-09-18",
    articleReference: "Art. 6-7 din OUG 155/2024",
    relatedQuestions: ["1", "2", "8"],
  },
  {
    id: "4",
    question: "Ce măsuri minime de securitate cibernetică sunt obligatorii?",
    answer: `Conform Art. 21 din OUG 155/2024, toate entitățile vizate trebuie să implementeze următoarele măsuri:

1. POLITICI DE GESTIONARE A RISCURILOR
- Analiză periodică a riscurilor (cel puțin anual)
- Politici de securitate documentate și aprobate
- Evaluarea impactului asupra continuității activității
- Planuri de răspuns la incidente

2. MANAGEMENTUL INCIDENTELOR DE SECURITATE CIBERNETICĂ
- Proceduri de detectare a incidentelor
- Echipă dedicată sau responsabil desemnat
- Sisteme de monitorizare 24/7
- Proceduri de escaladare și notificare

3. CONTINUITATEA ACTIVITĂȚII ȘI GESTIONAREA CRIZELOR
- Plan de continuitate actualizat
- Sisteme de backup și recuperare
- Proceduri de restaurare (RPO/RTO definite)
- Teste periodice ale planurilor (minimum bianual)

4. SECURITATEA LANȚULUI DE APROVIZIONARE
- Evaluarea furnizorilor din perspectiva securității
- Clauze contractuale specifice securității cibernetice
- Monitorizarea continuă a furnizorilor critici
- Planuri alternative pentru furnizori esențiali

5. MĂSURI PENTRU ACHIZIȚIE, DEZVOLTARE, MENTENANȚĂ
- Proceduri de secure development lifecycle
- Testare de securitate pentru noi sisteme
- Gestionarea patch-urilor și actualizărilor
- Change management securizat

6. CRIPTARE ȘI AUTENTIFICARE MULTI-FACTOR
- Criptarea datelor în tranzit și în repaus
- MFA pentru toate accesele privilegiate
- Gestionarea cheilor criptografice
- Politici stricte pentru parole

7. CONTROL ACCES ȘI GESTIONARE ACTIVE
- Principiul privilegiului minim
- Inventar complet al activelor IT
- Segregarea funcțiilor critice
- Revizuiri periodice ale acceselor

8. FORMARE ANGAJAȚI
- Program de conștientizare în securitate cibernetică
- Training periodic (minimum anual)
- Simulări de phishing
- Instruire specifică pentru roluri critice

NOTĂ IMPORTANTĂ
Aceste măsuri sunt MINIMALE. În funcție de sectorul de activitate și nivelul de risc, pot fi necesare măsuri suplimentare specifice.`,
    category: "security",
    subcategory: "protectia-retelelor",
    tags: ["Măsuri securitate", "Obligatoriu", "Conformitate"],
    votes: 1978,
    views: 11234,
    lastUpdated: "2024-09-22",
    articleReference: "Art. 21 din OUG 155/2024",
    relatedQuestions: ["5", "7", "9"],
    urgent: true,
  },
  {
    id: "5",
    question: "Cum se raportează incidentele de securitate cibernetică?",
    answer: `Procedura de raportare a incidentelor conform OUG 155/2024:

NOTIFICARE INIȚIALĂ (Early Warning)
Termen: 24 de ore de la detectare

Conținut minim:
- Descrierea incidentului
- Tipul de amenințare sau cauză probabilă
- Măsurile tehnice aplicate

Destinatar:
- CERT-RO (incidente@cert.ro)
- Autoritatea sectorială competentă

RAPORTARE INTERMEDIARĂ
Termen: 72 de ore de la detectare

Conținut:
- Actualizare privind evoluția incidentului
- Gravitatea și impactul
- Indicatori de compromitere (IoC)
- Măsuri de atenuare în curs

RAPORT FINAL
Termen: 1 lună de la raportarea inițială

Conținut complet:
- Descrierea detaliată a incidentului
- Tipul amenințării și vectorul de atac
- Măsurile aplicate pentru atenuare
- Măsurile de prevenire implementate pentru viitor
- Efectele transfrontaliere (dacă există)

CE INCIDENTE TREBUIE RAPORTATE

TREBUIE raportate incidente semnificative care:
- Au cauzat sau pot cauza perturbări semnificative
- Afectează disponibilitatea serviciilor
- Produc pierderi financiare substanțiale
- Compromit confidențialitatea datelor
- Afectează integritatea sistemelor/datelor

NU se raportează:
- Tentative blocate fără impact
- Incidente minore gestionate intern
- False pozitive din sisteme de detectare

CANALE DE RAPORTARE

CERT-RO
Email: incidente@cert.ro
Telefon: +40 21 311 48 42
Portal web: https://cert.ro/raportare

DNSC
Portal dedicat (va fi comunicat)
Email oficial pentru incidente

SANCȚIUNI PENTRU NERAPORTARE

Entități esențiale:
Amendă până la 10.000.000 EUR sau 2% CA

Entități importante:
Amendă până la 7.000.000 EUR sau 1,4% CA

RECOMANDARE
În caz de dubiu, raportați! Este mai bine să raportați un incident care se dovedește mai puțin semnificativ decât să nu raportați unul major.`,
    category: "reporting",
    subcategory: "incidente-semnificative",
    tags: ["Raportare", "CERT-RO", "Obligatoriu", "Incidente"],
    votes: 1654,
    views: 8901,
    lastUpdated: "2024-09-19",
    articleReference: "Art. 23-24 din OUG 155/2024",
    relatedQuestions: ["4", "6", "11"],
    urgent: true,
  },
  {
    id: "6",
    question: "Care sunt amenzile pentru neconformitate?",
    answer: `Regimul de sancțiuni conform OUG 155/2024:

PENTRU ENTITĂȚI ESENȚIALE

Neimplementarea măsurilor de securitate:
- Până la 10.000.000 EUR SAU 2% din cifra de afaceri anuală globală (se aplică suma mai mare)

Nerespectarea obligațiilor de raportare:
- Până la 7.000.000 EUR SAU 1,4% din cifra de afaceri anuală globală

Furnizarea de informații incorecte:
- Până la 7.000.000 EUR SAU 1,4% din cifra de afaceri anuală globală

PENTRU ENTITĂȚI IMPORTANTE

Neimplementarea măsurilor de securitate:
- Până la 7.000.000 EUR SAU 1,4% din cifra de afaceri anuală globală (se aplică suma mai mare)

Nerespectarea obligațiilor de raportare:
- Până la 5.000.000 EUR SAU 1% din cifra de afaceri anuală globală

Furnizarea de informații incorecte:
- Până la 5.000.000 EUR SAU 1% din cifra de afaceri anuală globală

CIRCUMSTANȚE AGRAVANTE

Amenzile pot fi majorate în cazul:
- Încălcărilor repetate
- Refuzului de cooperare cu autoritățile
- Obstrucționării anchetelor
- Neimplementării măsurilor corective solicitate
- Impactului semnificativ asupra serviciilor esențiale

CIRCUMSTANȚE ATENUANTE

Amenzile pot fi reduse dacă:
- Este prima abatere
- Există cooperare deplină cu autoritățile
- S-au luat măsuri imediate de remediere
- Impactul a fost minim
- Entitatea poate demonstra eforturi reale de conformare

ALTE MĂSURI SUPLIMENTARE

Pe lângă amenzi, autoritățile pot dispune:
- Avertismente publice
- Suspendarea temporară a certificatelor
- Obligarea la audituri suplimentare (pe cheltuiala entității)
- Obligarea la implementarea imediată a măsurilor corective
- Publicarea neconformităților

EXEMPLE DE CALCUL

Exemplu 1: Companie cu CA 100 mil EUR
2% = 2.000.000 EUR (sub 10 mil EUR)
Amendă aplicabilă: până la 10.000.000 EUR

Exemplu 2: Companie cu CA 1 miliard EUR
2% = 20.000.000 EUR (peste 10 mil EUR)
Amendă aplicabilă: până la 20.000.000 EUR

PREVENȚIE
Costurile de implementare a măsurilor de securitate sunt MULT mai mici decât amenzile. Investiția în conformare este esențială!`,
    category: "reporting",
    subcategory: "amenzi",
    tags: ["Sancțiuni", "Amenzi", "Neconformitate"],
    votes: 2341,
    views: 14567,
    lastUpdated: "2024-09-21",
    articleReference: "Art. 34-36 din OUG 155/2024",
    relatedQuestions: ["2", "5", "13"],
    urgent: true,
  },
  {
    id: "7",
    question: "Trebuie să avem un CISO (Chief Information Security Officer)?",
    answer: `Cerințe privind funcția de CISO conform OUG 155/2024:

OBLIGATORIU PENTRU

- Toate entitățile esențiale
- Entitățile importante cu peste 250 angajați
- Organizații cu riscuri ridicate de securitate cibernetică

ROLUL ȘI RESPONSABILITĂȚILE CISO

Responsabilități principale:
- Supravegherea implementării măsurilor de securitate
- Coordonarea răspunsului la incidente
- Raportarea către management și consiliul de administrație
- Interfața cu autoritățile competente (DNSC, CERT-RO)
- Coordonarea auditurilor de securitate

Competențe necesare:
- Cunoștințe aprofundate în securitate cibernetică
- Experiență în managementul riscurilor
- Înțelegerea cadrului legal și regulamentar
- Abilități de leadership și comunicare
- Certificări recomandate: CISSP, CISM, ISO 27001 Lead Auditor

Poziție ierarhică:
- Raportare directă către top management
- Acces direct la consiliul de administrație
- Independență față de alte departamente
- Autoritate în decizii de securitate

ALTERNATIVE PENTRU ENTITĂȚI MAI MICI

Dacă nu este obligatoriu un CISO dedicat:

Responsabil securitate informații (RSI):
- Poate avea și alte responsabilități
- Minim 50% timp alocat securității
- Formare specializată obligatorie

Externalizare parțială:
- Contract cu consultant extern
- Prezență periodică în organizație
- Responsabilitate internă pentru implementare

Shared CISO:
- CISO comun pentru grup de companii
- Legal permis pentru companii din același grup
- Trebuie să existe resursă dedicată pentru fiecare entitate

OBLIGAȚII MANAGEMENT DE VÂRF

Indiferent de existența unui CISO:

Consiliul de administrație/Management este RĂSPUNZĂTOR de:
- Aprobarea politicilor de securitate
- Alocarea resurselor necesare
- Supravegherea implementării măsurilor
- Participarea la training-uri de conștientizare
- Răspunderea pentru neconformități

SANCȚIUNI PENTRU MANAGEMENT

În caz de neconformitate gravă:
- Răspundere personală a membrilor CA
- Posibile sancțiuni pecuniare individuale
- Interdicții temporare de a exercita funcții de conducere

RECOMANDĂRI

- Desemnați o persoană responsabilă chiar dacă nu este obligatoriu
- Asigurați formare continuă pentru responsabilul de securitate
- Definiți clar roluri și responsabilități
- Alocați buget dedicat pentru securitate cibernetică
- Asigurați-vă că management înțelege importanța securității`,
    category: "compliance",
    subcategory: "masuri-organizatorice",
    tags: ["CISO", "Management", "Roluri", "Responsabilități"],
    votes: 1432,
    views: 7823,
    lastUpdated: "2024-09-17",
    articleReference: "Art. 20 din OUG 155/2024",
    relatedQuestions: ["4", "14", "15"],
  },
  {
    id: "8",
    question: "Ce sectoare sunt acoperite de NIS2 în România?",
    answer: `Lista completă a sectoarelor vizate de OUG 155/2024:

SECTOARE ESENȚIALE

1. ENERGIE
- Energie electrică, Petrol și gaze naturale, Hidrogen, Rețele de încălzire și răcire

2. TRANSPORT
- Transport aerian, Transport feroviar, Transport naval, Transport rutier

3. SECTORUL BANCAR
- Instituții de credit, Instituții de plată, Instituții emitente de monedă electronică

4. INFRASTRUCTURI PIEȚELOR FINANCIARE
- Operatori de piață reglementată, Depozitare centrală, Contrapărți centrale

5. SĂNĂTATE
- Furnizori servicii medicale, Laboratoare medicale, Cercetare produse farmaceutice, Producție substanțe active farmaceutice

6. APĂ POTABILĂ
- Producție, prelucrare, distribuție

7. INFRASTRUCTURĂ DIGITALĂ
- Puncte de schimb internet (IXP), Furnizori servicii DNS, Registre TLD, Furnizori servicii cloud, Centre de date, CDN, Servicii comunicații electronice

8. ADMINISTRAȚIE PUBLICĂ
- Administrație publică centrală, Administrație publică regională

9. SPAȚIUL COSMIC
- Operatori infrastructuri spațiale

SECTOARE IMPORTANTE

10. SERVICII POȘTALE ȘI DE CURIERAT
- Furnizori servicii poștale, Servicii de curierat

11. MANAGEMENTUL DEȘEURILOR
- Colectare, transport, tratare deșeuri

12. PRODUCȚIE CHIMICE
- Substanțe chimice, Produse chimice

13. PRODUCȚIE ALIMENTE
- Producție alimentară, Prelucrare și distribuție

14. PRODUCȚIE
- Echipamente medicale, Calculatoare și electronice, Mașini și echipamente, Autovehicule

15. FURNIZORI SERVICII DIGITALE
- Piețe online, Motoare de căutare, Platforme servicii rețele sociale

16. CERCETARE ȘTIINȚIFICĂ
- Organizații de cercetare

17. MATERII PRIME CRITICE
- Producție, prelucrare, distribuție

CUM SE DETERMINĂ DACĂ SUNTEȚI VIZAT

Verificați:
1. Sectorul în care activați
2. Dimensiunea organizației (peste 50 angajați plus peste 10 mil EUR CA/bilanț)
3. Tipul serviciilor furnizate
4. Importanța critică a serviciului

CAZURI SPECIALE

Micro-întreprinderi și IMM-uri:
Excluse în general, EXCEPTÂND singuri furnizori într-o regiune sau servicii critice fără alternative

Grupuri de companii:
Fiecare entitate evaluată individual

Activități multiple:
Dacă o companie activează în multiple sectoare, se aplică cea mai strictă categorie

NU ȘTII SIGUR DACĂ EȘTI VIZAT

Contactează:
DNSC: contact@dnsc.ro
Linia de asistență NIS2: (va fi anunțat)
Portal evaluare: (în curs de dezvoltare)`,
    category: "entities",
    subcategory: "sectoare-acoperite",
    tags: ["Sectoare", "Clasificare", "Eligibilitate"],
    votes: 1765,
    views: 10234,
    lastUpdated: "2024-09-16",
    articleReference: "Anexa 1 și 2 din OUG 155/2024",
    relatedQuestions: ["1", "3", "9"],
  },
];

export const trendingQuestions = faqQuestions.slice(0, 8);
